import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker,
} from 'antd';
const FormItem = Form.Item;
import {formatFormData} from './utils';
import { actions, asyncGet } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(formatFormData(values));
        this.props.resetPagination();
        this.props.asyncGet();
    }
    sendCommend = () => {
        // 下发命令
        this.props.editShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const {pricpleList} = this.props;
        const pricpleOptin = pricpleList.map(item => {
            return (
                <Option key={item} value={item}>
                    {item}
                </Option>
            );
        });
        const dateFormat = 'YYYY-MM-DD';
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>签到列表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="开始时间">
                                {getFieldDecorator('beginTime', {
                                    initialValue: moment(moment().format(dateFormat)),
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入开始时间',
                                        },
                                    ],
                                }
                                )(<DatePicker format={dateFormat} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="结束时间">
                                {getFieldDecorator('endTime', {
                                    initialValue: moment(moment().format(dateFormat)),
                                }
                                )(<DatePicker format={dateFormat} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="时间段" {...spans}>
                                {getFieldDecorator('tr')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value='1000'>
                                            上午
                                        </Option>
                                        <Option key='2' value='1800'>
                                            下午
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="责任人" {...spans}>
                                {getFieldDecorator('pricple')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        {pricpleOptin}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pricpleList: state.signList.pricpleList,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isSendCommend: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/sign/signList/search.js